import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import AuthenticationPageNavigation from "components/authentication/AuthenticationPageNavigation";
import { PageHeader } from "components/common";
import useActiveBackend from "components/authentication/useActiveBackend";
import BackendActionLinks from "components/authentication/BackendActionLinks";
import DocsHelper from "util/DocsHelper";
import StringUtils from "util/StringUtils";
const _pageTitle = (t, authBackend) => {
  if (authBackend) {
    const backendTitle = StringUtils.truncateWithEllipses(authBackend.title, 30);
    return /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "wizard_header.edit_title", values: { backendTitle }, components: { emphasis: /* @__PURE__ */ React.createElement("i", null) } });
  }
  return t("active_directory.create_title");
};
const WizardPageHeader = ({ authenticationBackend: authBackend = void 0 }) => {
  const { t } = useTranslation("authentication");
  const { finishedLoading, activeBackend } = useActiveBackend();
  const pageTitle = _pageTitle(t, authBackend);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(AuthenticationPageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: pageTitle,
      actions: /* @__PURE__ */ React.createElement(BackendActionLinks, { activeBackend, finishedLoading }),
      documentationLink: {
        title: t("page.documentation_title"),
        path: DocsHelper.PAGES.USERS_ROLES
      }
    },
    /* @__PURE__ */ React.createElement("span", null, t("page.description"))
  ));
};
export default WizardPageHeader;
